import { observer } from "mobx-react";
import { Login } from "./loginComponents";
import { LoginView as Login2 } from "./loginComponents2";
import { useLoginModel } from "./loginDomain";
import { Layout } from "../containers/DefaultLayout/DefaultLayout";
import { isProductionEnvironment } from "../utils/environments";

const LoginPage = observer(function LoginPage() {
  const model = useLoginModel();
  return isProductionEnvironment() ? (
    <Layout>
      <Login model={model} />
    </Layout>
  ) : (
    <Login2 model={model} />
  );
});

export default LoginPage;
